"use client";

import React, { useState } from "react";
import Image from "next/image";
import styles from "./AIMLTechStack.module.css";
import { aiMlTechTabs, aiMlTechItems } from "../../data/ai-ml";

function Logo({ text, category, iconClass, logo }) {
  const letters = (text || "")
    .trim()
    .split(/\s+/)
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const catClass =
    category === "genai"
      ? styles["cat-genai"]
      : category === "nn"
      ? styles["cat-nn"]
      : category === "dl"
      ? styles["cat-dl"]
      : category === "toolkits"
      ? styles["cat-toolkits"]
      : category === "mlops"
      ? styles["cat-mlops"]
      : category === "libs"
      ? styles["cat-libs"]
      : category === "vision"
      ? styles["cat-vision"]
      : "";
  const rootClass = `${styles.logo} ${logo ? "" : catClass}`.trim();
  return (
    <div className={rootClass}>
      {logo ? (
        <Image
          src={logo}
          alt={text}
          width={64}
          height={64}
          className={styles.logoImg}
          unoptimized
        />
      ) : iconClass ? (
        <i className={iconClass} aria-hidden />
      ) : (
        <span className={styles.logoText}>{letters}</span>
      )}
    </div>
  );
}

function iconForCategory(id) {
  switch (id) {
    case "genai":
      return "fa-solid fa-wand-magic-sparkles";
    case "nn":
      return "fa-solid fa-network-wired";
    case "dl":
      return "fa-solid fa-cubes";
    case "toolkits":
      return "fa-solid fa-toolbox";
    case "mlops":
      return "fa-solid fa-gears";
    case "libs":
      return "fa-solid fa-book";
    case "vision":
      return "fa-solid fa-eye";
    default:
      return "fa-solid fa-square";
  }
}

export default function AIMLTechStack() {
  const [active, setActive] = useState("genai");
  const items = aiMlTechItems[active] || [];

  return (
    <section className={styles.section}>
      <div className="container">
        <header className={styles.head}>
          <div className={styles.eyebrow}>TECHNOLOGY</div>
          <h2 className={styles.title}>
            Tech Stack Driving Digital Transformation with Generative AI
            Services
          </h2>
        </header>

        <div className={styles.wrapper}>
          {/* Left: Tabs */}
          <div className={styles.tabs}>
            {aiMlTechTabs.map((t) => (
              <button
                key={t.id}
                type="button"
                className={`${styles.tab} ${
                  active === t.id ? styles.active : ""
                }`}
                onClick={() => setActive(t.id)}
              >
                <span>{t.label}</span>
              </button>
            ))}
          </div>

          {/* Right: Grid */}
          <div>
            <div className={styles.grid}>
              {items.map((it) => (
                <div
                  key={it.name}
                  className={styles.card}
                  data-reveal="slide-up"
                >
                  <Logo
                    text={it.name}
                    category={active}
                    iconClass={iconForCategory(active)}
                    logo={it.logo}
                  />
                  <div className={styles.label}>{it.name}</div>
                  {it.sub && <div className={styles.sub}>{it.sub}</div>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
